<template>
  <div class="main-container">
    <router-view></router-view>
    <DepositModal />
    <WithdrawModal />

    <!-- Navbar section -->
    <HeaderStartup />

    <!-- breadcrumb strat -->
    <Breadcrumb>
      <template slot="breadcrumb">
        <div class="breadcrumb_box text-center">
          <h2 class="breadcrumb-title">Pixel Profile</h2>
        </div>
      </template>
    </Breadcrumb>
    <!-- breadcrumb end -->

    <!-- portfolio details wrapper start -->
    <div class="portfolio-details-wrapper section-space--ptb_100">
      <div class="container">
        <div class="row portfolio-details-feature-wrap">
          <div class="col-lg-8">
            <div class="portfolio-details-content">
              <div class="portfolio-details-title">
                <!-- <a class="portfolio-categories" href="#">Concept</a> -->
                <h3 class="portfolio-details-title mb-2">My Pixel Profile</h3>
              </div>
              <div class="mb-2">
                <div v-if="connectedWalletAddress === null">
                  <b-button @click="connectWallet" class="ht-btn ht-btn-xs">
                    Connect Wallet
                  </b-button>
                </div>
                <div v-else>
                  <b-button v-b-modal.deposit class="ht-btn ht-btn-xs mr-2">
                    Deposit $PXL
                  </b-button>
                  <b-button v-b-modal.withdraw class="ht-btn ht-btn-xs"> Withdraw $PXL </b-button>
                </div>
              </div>
              <p v-if="this.pxlBalance.pending_withdrawals.length" class="mb-0">
                Pending Withdrawals:
              </p>
              <ul class="list-unstyled d-inline-flex flex-wrap mb-0">
                <b-card
                  v-for="pending_withdrawal in this.pxlBalance.pending_withdrawals"
                  :key="pending_withdrawal.amount"
                  tag="li"
                  class="mt-1 mr-1"
                  body-class="py-1 pr-2 text-nowrap"
                >
                  <strong class="text-stroke">
                    {{ convertFromMutez(pending_withdrawal.amount) }} -
                    {{ new Date(pending_withdrawal.createdAt) | dateWithTime }}
                  </strong>
                  <b-button v-b-modal.cancelPendingWithdrawal class="ht-btn ht-btn-xs">X </b-button>
                  <b-modal
                    id="cancelPendingWithdrawal"
                    ref="modal"
                    title="Cancel Pending Withdrawal"
                    @ok="cancelPendingWithdrawal(pending_withdrawal.id)"
                    ok-title="Cancel Withdraw"
                  >
                    <p>Are you sure you want to cancel this withdraw?</p>
                  </b-modal>
                </b-card>
              </ul>
              <!-- <ul>
                <li v-for="pending_withdrawal in this.pxlBalance.pending_withdrawals" :key="pending_withdrawal.amount">
                  {{ pending_withdrawal.amount / 1000000 }}
                </li>
              </ul> -->
              <!-- <div class="text mt-20">
                <p>
                  The studio was keen to create an identity that would not interfere with any of the
                  existing brands, settling on a helicoid system that can be easily adapted to “work
                  with any colour system”. The studio consulted with the various brands throughout
                  the process. (Source: designweek.co.uk)
                </p>
              </div> -->
              <div class="portfolio-details-table table-responsive mt-30">
                <table class="table mb-0">
                  <tbody>
                    <tr class="portfolio-details-date">
                      <td class="label">Available $PXL</td>
                      <td>{{ convertFromMutez(this.pxlBalance.available) }}</td>
                    </tr>
                    <tr class="portfolio-details-client">
                      <td class="label">On Hold $PXL</td>
                      <td>{{ convertFromMutez(this.pxlBalance.hold) }}</td>
                    </tr>
                    <tr class="portfolio-details-tags">
                      <td class="label">Total $PXL Balance</td>
                      <td class="total">{{ convertFromMutez(this.pxlBalance.total) }}</td>
                    </tr>
                    <hr />
                    <tr class="" style="white-space: nowrap">
                      <b-button
                        v-if="connectedWalletAddress !== null"
                        v-b-modal.alias
                        class="ht-btn ht-btn-xs mb-3 mr-2"
                      >
                        {{ user && user.alias ? 'Change Alias' : 'Add Alias' }}
                      </b-button>
                      <b-button v-b-modal.email class="ht-btn ht-btn-xs mb-3 mr-2">
                        Change Email Address
                      </b-button>
                      <b-button v-b-modal.password class="ht-btn ht-btn-xs mb-3"
                        >Change Password
                      </b-button>
                    </tr>
                    <tr class="portfolio-details-tags">
                      <td class="label">Alias:</td>
                      <td>{{ user && user.alias }}</td>
                    </tr>
                    <ChangeAliasModal />
                    <tr class="portfolio-details-tags">
                      <td class="label">Email Address:</td>
                      <td>{{ user && user.email }}</td>
                    </tr>
                    <ChangeEmailModal />
                    <tr class="portfolio-details-tags">
                      <td class="label">Wallet Address:</td>
                      <td>{{ user.walletAddress }}</td>
                    </tr>
                    <ChangePassModal />
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer section -->
    <FooterMain FooterStyle="bg_dark-footer" />

    <!-- offcanvas search component -->
    <OffcanvasSearchBox />

    <!-- off-canvas mobile menu -->
    <OffCanvasMobileMenu />
  </div>
</template>

<script>
import axios from 'axios'

import Breadcrumb from '@/components/Breadcrumb'
import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'
import OffcanvasSearchBox from '@/components/OffcanvasSearchBox'

import FooterMain from '../components/FooterMain'
import HeaderStartup from '../components/HeaderStartup'
import ChangeAliasModal from '../components/modals/ChangeAliasModal'
import ChangeEmailModal from '../components/modals/ChangeEmailModal'
import ChangePassModal from '../components/modals/ChangePassModal'
import DepositModal from '../components/modals/DepositModal'
import WithdrawModal from '../components/modals/WithdrawModal'
import { convertFromMutez, handleGlobalError } from '../util'
export default {
  name: 'PortfolioGrid',
  components: {
    Breadcrumb,
    ChangeAliasModal,
    ChangeEmailModal,
    ChangePassModal,
    DepositModal,
    HeaderStartup,
    FooterMain,
    OffcanvasSearchBox,
    OffCanvasMobileMenu,
    WithdrawModal,
  },
  metaInfo: {
    title: 'Pixel Profile',
    htmlAttrs: {
      lang: 'en',
      amp: true,
    },
  },
  mounted() {
    if (this.user === null) {
      this.$router.push('/login')
    } else if (this.$store.getters.user.isVerified == false) {
      this.$router.push({ path: '/verify', query: { email: this.$store.getters.user.email } })
    } else if (this.$store.getters.user.walletAddress === null) {
      this.$router.push({ path: `associate-wallet` })
    }
    this.getBalance()
    this.getConfig()
    this.updateUserFromServer()
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    wallet() {
      return this.$store.getters.wallet
    },
    walletAddress() {
      return this.user ? this.user.walletAddress : null
    },
    connectedWalletAddress() {
      return this.$store.getters.connectedWalletAddress
    },
    tezos() {
      return this.$store.getters.tezos
    },
    pxlBalance() {
      return this.$store.getters.pxlBalance
    },
  },
  methods: {
    convertFromMutez,
    async connectWallet() {
      try {
        await this.wallet.requestPermissions({
          network: {
            type: process.env.VUE_APP_TEZOS_NETWORK,
            rpcUrl: process.env.VUE_APP_TEZOS_RPC,
          },
        })
        const connectedWalletAddress = await this.wallet.getPKH()
        if (connectedWalletAddress !== this.walletAddress) {
          // TODO turn this into a toast
          alert(
            `Trying to connect wallet with address ${connectedWalletAddress}, however the associated wallet is ${this.walletAddress}.  You must connect the previously associated wallet or create a new Pixel Profile.`
          )
          return
        }
        this.tezos.setProvider({ wallet: this.wallet })

        this.$store.commit('initializeConnectedWalletAddress', connectedWalletAddress)
      } catch (e) {
        console.error('Unable to connect wallet', e)
      }
    },
    async getBalance() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_PXL_API}/pxl-balance/`)
        this.$store.commit('updatePxlBalance', {
          available: response.data.availableBalance,
          hold: response.data.holdBalance,
          total: response.data.totalBalance,
          pending_withdrawals: response.data.pending_withdrawals,
        })
      } catch (error) {
        console.error('error trying to get balance', error)
        handleGlobalError(this, error, 'getting balance')
      }
    },
    async getConfig() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_PXL_API}/debates-client-config/`)
        this.$store.commit('updateConfig', {
          maxDeposit: response.data.maxDeposit,
          maxWithdrawal: response.data.maxWithdrawal,
        })
      } catch (error) {
        console.error('error trying to get config', error)
        handleGlobalError(this, error, 'getting config')
      }
    },
    async cancelPendingWithdrawal(pendingWithdrawalId) {
      try {
        await axios.post(`${process.env.VUE_APP_PXL_API}/pending-withdrawal/cancel`, {
          pendingWithdrawalId,
        })
        this.successToast()
        this.getBalance()
      } catch (error) {
        console.error('error trying to cancel pending withdrawal', error)
        handleGlobalError(this, error, 'cancel pending withdrawal')
      }
    },
    async updateUserFromServer() {
      try {
        const selfResp = await axios.get(`${process.env.VUE_APP_PXL_API}/users`)
        if (selfResp && selfResp.data && selfResp.data.data.length === 1) {
          const u = selfResp.data.data[0]
          console.log()
          this.$store.commit('updateUser', u)
        }
      } catch (error) {
        console.error('error trying to update user', error)
      }
    },
    successToast() {
      this.$bvToast.toast('Pending withdrawal has successfully been cancelled.', {
        title: 'Success',
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-top-center',
      })
    },
  },
}
</script>
<style>
.breadcrumb-title,
.breadcrumb-list,
.breadcrumb-list li.active {
  color: white;
}

table {
  table-layout: fixed;
}

th,
td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
